import { useMutationUserPreferencesUpdate } from '../../user/mutations/useMutationUserPreferencesUpdate.js';
import { userQueryKeys } from '../../user/queries/userQueryKeys.js';
import { useQueryClient, useMutation } from '@tanstack/react-query';

const useMutationCheckListItemState = () => {
  const mutationUserPreferencesUpdate = useMutationUserPreferencesUpdate();
  const queryClient = useQueryClient();
  return useMutation({
    /**
    * if the actions is already completed, mutation will ignore the update automatically
    */
    mutationFn: async ({ actionId, state }) => {
      const queryState = queryClient.getQueryState(userQueryKeys.userPreferences());
      if (queryState) {
        const { status, data: preferences } = queryState;
        if ([
          "pending"
        ].includes(status) || preferences?.frontend?.onboardingChecklist?.[actionId] === state) {
          return;
        }
        await mutationUserPreferencesUpdate.mutateAsync({
          data: {
            frontend: {
              ...preferences?.frontend,
              onboardingChecklist: {
                ...preferences?.frontend?.onboardingChecklist,
                [actionId]: state
              }
            }
          },
          showToast: false
        });
      }
    },
    scope: {
      id: "checklist-item-state"
    }
  });
};

export { useMutationCheckListItemState };
//# sourceMappingURL=useMutationCheckListItemState.js.map
